module.exports = __webpack_public_path__ + "27817ff4c321eafbc76dd529717221e9.png";